import { create } from "zustand";
import { persist } from "zustand/middleware";
import { UserAdministrationInfo } from "../common/interfaces/common.interface";

interface UserStore {
  userInfo: UserAdministrationInfo | null;
  setUserInfo: (user: UserAdministrationInfo) => void;
  clear: () => void;
}

export const useUserStore = create<UserStore>()(
  persist(
    (set) => ({
      userInfo: null,
      setUserInfo: (user) => set({ userInfo: user }),
      clear: () => set({ userInfo: null }),
    }),
    {
      name: "user-storage",
      partialize: (state) => ({ userInfo: state.userInfo }),
    }
  )
);
